module.exports = __webpack_public_path__ + "media/images/logo_en-2b5d5ce39873848bf13beff075c7b11c.svg";